import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { getJobPositions } from '@/services/jobPositions.service';

export const JOB_POSITIONS_QUERY_KEY = 'job-positions';

const ROMAN = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII'];

/**
 * Short required level of a catalog position: "IV", or the typed text of
 * `other` ("IV/V").
 */
export const jobPositionLevelShort = (position) => {
  const level = position?.educationLevel;
  if (!level) return '';
  if (level === 'other') return position.educationLevelOther || '';
  const rs = /^rsLevel([1-8])$/.exec(level);
  return rs ? ROMAN[Number(rs[1]) - 1] : level;
};

/**
 * The company's catalog of job positions. `enabled: false` while there is no
 * company.
 */
export default function useJobPositions(companyId, status = 'active') {
  return useQuery({
    queryKey: [JOB_POSITIONS_QUERY_KEY, companyId, status],
    queryFn: () => getJobPositions(companyId, status),
    enabled: !!companyId,
    retry: false,
    staleTime: 60 * 1000,
  });
}

/** `jobPositions.<key>` of the translations namespace. */
export function useJobPositionsT() {
  const { t } = useTranslation(['translations', 'forms']);
  const tj = useCallback(
    (key, opts) => t(`jobPositions.${key}`, { ns: 'translations', ...opts }),
    [t]
  );
  return { t, tj };
}
